import React, { memo } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line, Bar, Pie } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

interface ChartRendererProps {
  config: any;
  type: 'line' | 'bar' | 'pie';
}

const ChartRenderer: React.FC<ChartRendererProps> = memo(({ config, type }) => {
  const commonOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: config.options?.plugins?.title?.text || 'Chart',
      },
    },
    ...config.options,
  };

  const chartData = {
    labels: config.data?.labels || [],
    datasets: config.data?.datasets || [],
  };

  const containerStyle = {
    height: '400px',
    width: '100%',
    margin: '16px 0',
    padding: '16px',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e4e4e7',
  };

  switch (type) {
    case 'line':
      return (
        <div style={containerStyle}>
          <Line data={chartData} options={commonOptions} />
        </div>
      );
    case 'bar':
      return (
        <div style={containerStyle}>
          <Bar data={chartData} options={commonOptions} />
        </div>
      );
    case 'pie':
      return (
        <div style={containerStyle}>
          <Pie data={chartData} options={commonOptions} />
        </div>
      );
    default:
      return (
        <div style={{
          ...containerStyle,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#a1a1aa',
        }}>
          Unsupported chart type: {type}
        </div>
      );
  }
});

export default ChartRenderer;